import React from 'react'
// import styles from './styles.module.scss'
import { Image, MDX as Mdx } from 'contentbricks'
// import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
// import { groups } from 'components/main/groups'

export interface GroupSegment {
  group: {
    id: string
    layout: string
    name: string
    color: string
    title: string
    locator: string
    image: string
  }
}
export const GroupSegment = ({ group }: GroupSegment) => {
  return (
    <div className='ui vertical  segment'>
      <div className='ui container' style={{ textAlign: 'center' }}>
        <img
          src={require('images/map_icons_' + group.id + '.png')}
          width='40px'
        />
        <h4
          style={{ color: group.color }}
          dangerouslySetInnerHTML={{ __html: group.title }}
        />
        {/* <div className='umsatz'>
          <div className='key'>Jährlicher Umsatz:</div>
          <div className='value'>{group.volume}</div>
        </div> */}
        <div className='ui stackable grid'>
          <div className='eight wide column'>
            <Image
              file={require('images/' + group.id + '_1.jpg')}
              source={group.header_source && group.header_source}
            />
          </div>
          <div className='eight wide column'>
            {/* <AutofitIFrame src={group.locator} /> */}
            <Image file={require('images/maps_' + group.id + '.jpg')} />
          </div>
        </div>
        <div className='ui text container' style={{ textAlign: 'left' }}>
          <Mdx file={require('text/' + group.id + '.mdx')} />
        </div>
      </div>
    </div>
  )
}
